// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// ⚠️ store 必须第一个导入，确保 setActivePinia 在所有模块之前执行
import store from './store'
import Vue from 'vue'
import App from './App'
import router from './router'
import { initWeChatSdk } from '@/utils/wechat'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  pinia: store,
  components: { App },
  template: '<App/>'
})

// Vue 2 路由就绪后初始化微信JSSDK
router.onReady(() => {
  initWeChatSdk()
  router.afterEach(() => initWeChatSdk())
})



// WEBPACK FOOTER //
// ./src/main.js